// Cloud file download proxy utility
import { getConfig } from '../config/app.config';

export interface CloudFileDownloadRequest {
    downloadUrl: string;
    accessToken?: string;
    fileName?: string;
}

export interface CloudFileDownloadResponse {
    base64Data: string;
    fileName: string;
    contentType: string;
    size: number;
}

export const downloadCloudFile = async (request: CloudFileDownloadRequest): Promise<CloudFileDownloadResponse> => {
    const apiUrl = getConfig('VITE_BASE_URL');
    
    try {
        const response = await fetch(`${apiUrl}/files/download-cloud-file`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request)
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
        }
        
        return await response.json();
    } catch (error) {
        console.error('Cloud file download failed:', error);
        throw error;
    }
}; 